import React from 'react';

import classes from '../../style.module.scss';
import { categoryIcons } from '../../utils/categoryIconMap';

interface PageCategoryProps {
  appMeta: {
    title: string;
    type: string;
  };
  featureOptions: object;
}

const PageCategory = ({ appMeta, featureOptions }: PageCategoryProps) => (
  <div className={classes['Header-left-nav']}>
    <i className={`${categoryIcons[appMeta?.type]} ${classes['Header-left-nav-icon']}`} />
    {featureOptions?.[appMeta?.type]}
    {appMeta?.type === 'custompage' && appMeta.title}
    {appMeta?.type === '404' && 'Page Not Found'}
  </div>
);

export default PageCategory;
